export default [
    {
        path: 'atendimento-domiciliar',
        component: () => import(
            '@/views/atencao-basica/atendimento-domiciliar/Index'
        ),
        redirect: 'atendimento-domiciliar/index',
        children: [
            {
                name: 'atencao-basica-atendimento-domiciliar',
                path: 'index',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/atendimento-domiciliar/List'
                ),
            },
            {
                name: 'atencao-basica-atendimento-domiciliar-create',
                path: 'create',
                props: true,
                component: () => import(
                    '@/views/atencao-basica/atendimento-domiciliar/Form'
                )
            },
        ],
    },
]